var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-title"},[_c('img',{staticClass:"logo",attrs:{"src":require('@/assets/images/installDesc/logoWithTitle.png')}}),_c('img',{staticClass:"title",attrs:{"src":require('@/assets/images/installDesc/title.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }